export enum EDialogCloseEventStatus {
  OK,
  CANCEL,
  CLOSE,
  ERROR,
}
